import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-repairManage",
  "use": "icon-repairManage-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-repairManage\"><path d=\"M906.752 230.912A212.992 212.992 0 0 1 862.208 460.8a200.704 200.704 0 0 1-245.248 33.28L563.2 555.52l40.448 41.472 24.064-24.576a31.744 31.744 0 0 1 44.544 0l195.072 201.728a32.768 32.768 0 0 1 0 45.568l-89.088 91.136a31.744 31.744 0 0 1-44.544 0l-195.584-201.728a32.768 32.768 0 0 1 0-45.568l22.016-22.528-38.4-39.424-272.384 301.568a61.952 61.952 0 0 1-89.6 0l-22.016-22.528a65.536 65.536 0 0 1 0-91.136l307.2-263.168-204.8-209.408H176.64L102.4 194.048l59.392-61.952 122.88 77.312v64.512l204.8 211.968 59.904-51.2a211.968 211.968 0 0 1 19.968-271.36 201.728 201.728 0 0 1 222.208-45.568l-129.024 133.12 111.104 113.664zM211.456 821.76a30.72 30.72 0 0 0-44.544 0 32.768 32.768 0 0 0 0 45.568 31.744 31.744 0 1 0 44.544-45.568z\" fill=\"\" p-id=\"4757\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/repairManage.svg
// module id = 62dV
// module chunks = 32